var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 2.16797C18.3332 1.61568 17.8855 1.16797 17.3332 1.16797C16.7809 1.16797 16.3332 1.61568 16.3332 2.16797V3.33462H9.66677V2.16797C9.66677 1.61568 9.21906 1.16797 8.66677 1.16797C8.11449 1.16797 7.66677 1.61568 7.66677 2.16797V3.33462H5.41667C3.66777 3.33462 2.25 4.75239 2.25 6.50129V10.8346V21.668C2.25 23.4169 3.66777 24.8346 5.41667 24.8346H20.5833C22.3322 24.8346 23.75 23.4169 23.75 21.668V10.8346V6.50129C23.75 4.75239 22.3322 3.33462 20.5833 3.33462H18.3332V2.16797ZM21.75 9.83462V6.50129C21.75 5.85696 21.2277 5.33462 20.5833 5.33462H18.3332V6.5013C18.3332 7.05359 17.8855 7.5013 17.3332 7.5013C16.7809 7.5013 16.3332 7.05359 16.3332 6.5013V5.33462H9.66677V6.5013C9.66677 7.05359 9.21906 7.5013 8.66677 7.5013C8.11449 7.5013 7.66677 7.05359 7.66677 6.5013V5.33462H5.41667C4.77233 5.33462 4.25 5.85696 4.25 6.50129V9.83462H21.75ZM4.25 11.8346H21.75V21.668C21.75 22.3123 21.2277 22.8346 20.5833 22.8346H5.41667C4.77233 22.8346 4.25 22.3123 4.25 21.668V11.8346Z",
    fill: "url(#paint0_linear_2465_871)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2465_871",
    x1: 6.72917,
    y1: 19.9041,
    x2: 23.1153,
    y2: 7.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.013348a8cfc168a33187a786b445249c.svg";
export { ForwardRef as ReactComponent };